import React from "react";

const DeleteConfirmation = ({ handleDelete, deleteId, setDeleteMsg }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        backgroundColor: "rgba(0,0,0,0.5)",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          background: "white",
          padding: "10px",
          borderRadius: "10px",
          maxWidth: "500px",
          width: "100%",
          height: "140px",
          textAlign: "center",
        }}
      >
        <h6 style={{ color: "#111", fontSize: "18px", marginTop: "10px" }}>
          Do you want to delete {deleteId.name}?
        </h6>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
            marginTop: "30px",
          }}
        >
          <button
            onClick={() => handleDelete(deleteId.id)}
            style={{
              background: "red",
              color: "white",
              padding: "5px 20px",
              marginRight: "8px",
              fontSize: "14px",
              border: "none",
              cursor: "pointer",
            }}
            type="button"
          >
            Yes
          </button>
          <button
            onClick={() => setDeleteMsg(false)}
            style={{
              background: "green",
              color: "white",
              padding: "5px 20px",
              marginRight: "8px",
              fontSize: "14px",
              border: "none",
              cursor: "pointer",
            }}
            type="button"
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmation;
